import { pumaAPI } from "./api"
import { ICustomContentWidget } from "../models"
import {
    PumaPaginatedResponse,
    PumaParsedPaginatedResponse,
} from "./models/api/puma"
import { CustomContentWidgetDTO } from "./models/dto/customcontentwidget"

export const getCustomContentWidgets = (
    workspaceId: number | null,
): Promise<PumaParsedPaginatedResponse<ICustomContentWidget>> =>
    pumaAPI
        .getJSON("CustomContentWidgets", {
            // to ensure we sent the correct, expected value to the backend
            workspaceId: !!workspaceId && workspaceId > 0 ? workspaceId : null,
        })
        .then(
            (
                customContentWidgets: PumaPaginatedResponse<CustomContentWidgetDTO>,
            ) => ({
                paging: {
                    pageSize: customContentWidgets.Paging.PageSize,
                    totalRecordCount:
                        customContentWidgets.Paging.TotalRecordCount,
                },
                data: customContentWidgets.Data.$values.map(
                    (customContentWidget: CustomContentWidgetDTO) => ({
                        id: customContentWidget.Id,
                        content: customContentWidget.Content,
                        label: customContentWidget.Label,
                        workspaceId: customContentWidget.WorkspaceId,
                    }),
                ),
            }),
        )
